import React from 'react';
import Link from 'next/link';
import * as Icons from 'lucide-react';
import { categories } from '@/lib/data/categories';
import { LucideIcon } from 'lucide-react';

export function CategoryList() {
  return (
    <div className="bg-white rounded-lg shadow-sm border p-4">
      <h2 className="text-lg font-semibold mb-4 flex items-center gap-2">
        <Icons.List className="w-5 h-5 text-emerald-600" />
        Categories
      </h2>
      <div className="flex flex-wrap gap-2">
        {categories.map((category) => {
          const IconComponent = Icons[category.icon as keyof typeof Icons] as LucideIcon | undefined;
          return (
            <Link href={`/${category.name.toLowerCase().replace(/\s+/g, '-')}`} key={category.id} className="hover-lift">
              <div className="px-3 py-1.5 border rounded-full bg-emerald-50 hover:bg-emerald-100 hover:text-emerald-600 flex items-center gap-2 transition-all">
                {IconComponent && <IconComponent className="w-4 h-4 text-emerald-600" />}
                <span className="text-sm font-medium">{category.name}</span>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
